// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/feature_flag_rollouts_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementFeatureFlagRolloutsData } from "./constants";
import type { EngagementFeatureFlagRolloutsDataParams, GetFeatureFlagRolloutsDataResponse } from "./types";

export const getFeatureFlagRolloutsData = reactQueryTableFetcherAdapter(
  engagementFeatureFlagRolloutsData,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementFeatureFlagRolloutsDataParams
  ): Promise<GetFeatureFlagRolloutsDataResponse> => {
    const { created_start_date, created_end_date, last_edited_start_date, last_edited_end_date, ...strippedQuery } =
      query;

    return fetch(
      "/engagement/feature_flag_rollouts_data",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects({
          ...strippedQuery,
          ...formatCreatedAtTime(created_start_date, created_end_date),
          ...formatLastEditedTime(last_edited_start_date, last_edited_end_date),
        }),
      },
      { signal }
    );
  }
);

// Override query to backend so date fields are nested in "created_at"
const formatCreatedAtTime = (createdStartDate?: number, createdEndDate?: number) => {
  if (!createdStartDate && !createdEndDate) {
    return;
  }
  return {
    created: {
      start_date: createdStartDate,
      end_date: createdEndDate,
    },
  };
};

// Override query to backend so date fields are nested in "edited"
const formatLastEditedTime = (lastEditedStartDate?: number, lastEditedEndDate?: number) => {
  if (!lastEditedStartDate && !lastEditedEndDate) {
    return;
  }
  return {
    edited: {
      start_date: lastEditedStartDate,
      end_date: lastEditedEndDate,
    },
  };
};
